import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { JsonHttpService } from 'src/app/shared/http/json-http.service';
import { FileHttpService } from 'src/app/shared/http/file-http.service';

import { CompoundResult, GetCompareStatusResponse, GetImportStatusResponse, StartCompareResponse } from '../models/importer-status';

@Injectable({
  providedIn: 'root'
})
export class DeveloperImportService {

  constructor(
    private fileHttpService: FileHttpService,
    private httpService: JsonHttpService) { }

  startCompare(exportFile: File, ignoreVersionMismatch: boolean): Promise<StartCompareResponse> {
    const options = { params: new HttpParams().set('ignoreVersionMismatch', ignoreVersionMismatch) };
    return this.fileHttpService.upload<StartCompareResponse>('/api/developer/import/compare', [exportFile], options) as Promise<StartCompareResponse>;
  }

  getCompareStatus(statusGuid: string): Observable<GetCompareStatusResponse> {
    const options = { params: new HttpParams().set('statusGuid', statusGuid) };
    return this.httpService.get('/api/developer/import/get-compare-status', options);
  }

  startPartnerImport(compareResult: CompoundResult): Promise<void> {
    return this.httpService.post('/api/developer/import/import-partner', compareResult).toPromise();
  }

  startDistributionImport(compareResult: CompoundResult): Promise<void> {
    return this.httpService.post('/api/developer/import/import-distribution', compareResult).toPromise();
  }

  startDeveloperImport(compareResult: CompoundResult): Promise<void> {
    return this.httpService.post('/api/developer/import/import-developer', compareResult).toPromise();
  }

  startTransportImport(compareResult: CompoundResult): Promise<void> {
    return this.httpService.post('/api/developer/import/import-transport', compareResult).toPromise();
  }

  startComparePluginImport(compareResult: CompoundResult): Promise<void> {
    return this.httpService.post('/api/developer/import/import-compareplugin', compareResult).toPromise();
  }

  getImportStatus(): Observable<GetImportStatusResponse> {
    return this.httpService.get('/api/developer/import/get-import-status');
  }
}
